import { render, staticRenderFns } from "./YhContractDetails.vue?vue&type=template&id=2c1c891c&scoped=true"
import script from "./YhContractDetails.vue?vue&type=script&lang=js"
export * from "./YhContractDetails.vue?vue&type=script&lang=js"
import style0 from "./YhContractDetails.vue?vue&type=style&index=0&id=2c1c891c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1c891c",
  null
  
)

export default component.exports